import { render } from "./vreservenums.vue?vue&type=template&id=5d8dea14&scoped=true"
import script from "./vreservenums.vue?vue&type=script&lang=js"
export * from "./vreservenums.vue?vue&type=script&lang=js"

import "./vreservenums.vue?vue&type=style&index=0&id=5d8dea14&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8dea14"]])

export default __exports__